var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.164 35.475C77.685 26.001 64.132 20.785 50 20.785s-27.686 5.217-38.164 14.69a1.5 1.5 0 1 0 2.012 2.224C23.774 28.726 36.614 23.784 50 23.784s26.227 4.942 36.152 13.915a1.496 1.496 0 0 0 2.118-.106 1.5 1.5 0 0 0-.106-2.118Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33.708a43.91 43.91 0 0 0-29.501 11.355 1.5 1.5 0 1 0 2.012 2.224c7.548-6.822 17.31-10.58 27.489-10.58s19.941 3.758 27.489 10.58a1.496 1.496 0 0 0 2.118-.106 1.5 1.5 0 0 0-.106-2.118A43.91 43.91 0 0 0 50 33.708Zm0 14.445a29.493 29.493 0 0 0-19.817 7.629 1.5 1.5 0 1 0 2.012 2.224c4.889-4.419 11.212-6.854 17.806-6.854s12.917 2.435 17.806 6.854a1.496 1.496 0 0 0 2.118-.106 1.5 1.5 0 0 0-.106-2.118 29.493 29.493 0 0 0-19.817-7.629Zm0 13.844a15.666 15.666 0 0 0-10.526 4.068 1.5 1.5 0 0 0-.107 2.118l9.521 10.538a1.502 1.502 0 0 0 2.226 0l9.521-10.538a1.5 1.5 0 0 0-.107-2.118 15.668 15.668 0 0 0-10.526-4.068Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.5b669897de1b8092e53358b4eccadac2.svg";
export { ForwardRef as ReactComponent };